import { config } from '@/config';
import { initUserManager, User } from './oidc';
import { createValue } from './value';

export const session = createValue<User | null>(null);

const userManager = initUserManager(config.oidc);

export const getAppContainer = () => ({
  // application config
  config,

  // application session
  session,

  // application user managemenr
  userManager,
});

export type AppContainer = ReturnType<typeof getAppContainer>;
